import { Link } from 'remix';
import { InstagramIframe } from "~/components/InstagramIframe";

export const HashtagPage: React.VFC<HashtagPageProps> = ({ hashtagData }) => {
    const hashtagName = hashtagData[0].hashtags.hashtag_name;
    return (
        <>
            {/* ハッシュタグのタイトルを表示 */}
            <h1 className='hashTagTittle'>#{hashtagName}</h1>
            <ul className="shopLists">
                {hashtagData.map((item, index) => (
                    <li key={index} className="shopList">
                        <Link to={`/cafe/detail?shop=${item.shops.shop_id}`}>
                            <div className="shopImageContainer">
                                <h3>{item.shops.shop_name}</h3>
                                {item.shops.instagram_name ?
                                    <InstagramIframe src={item.shops.instagram_name} /> :
                                    <img src={`/images/article/shop/${item.shops.blog_detail_path}1.jpg`} alt={item.shops.shop_name} width="247" height="185" />
                                }
                            </div>
                        </Link>
                    </li>
                ))}
            </ul>
        </>
    );
};